import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["input", "count"]
  static values  = { max: Number }

  connect() {
    this.update()
  }

  update() {
    const len  = this.inputTarget.value.length
    const max  = this.maxValue
    const pct  = max > 0 ? len / max : 0
    const text = `${len}/${max}`

    this.countTarget.textContent = text

    if (pct >= 1) {
      this.countTarget.style.color = "#f87171"
    } else if (pct >= 0.85) {
      this.countTarget.style.color = "#fb923c"
    } else {
      this.countTarget.style.color = "rgba(255,255,255,0.3)"
    }
  }
}
